import getAPIUrl from '../../config';
import { getApi } from '../../utils/apiCalls';
import removeFalsyValues from '../../utils/customMethods';
import { MemberApiProps, PartnerApiProps } from './types';

const getMembers = async (data?: MemberApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/members`,
            data
                ? removeFalsyValues({
                      size: data.memberSize,
                      page: data.currentPage,
                      sort: data.sort,
                      order: data.order,
                      name: data.memberSearchText,
                      additionPeriod: data.selectedMemberPeriod,
                      isActive: data.selectedMemberStatus && data.selectedMemberStatus === 'active',
                      conditionId: data.selectedDiabetesType.filter((dt) => dt.checked).map((dt) => dt.value),
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export const getPartners = async (data?: PartnerApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/employers`,
            data
                ? removeFalsyValues({
                      size: data.partnerSize,
                      page: data.currentPage,
                      sort: data.sort,
                      order: data.order,
                      search: data.partnerSearchText,
                      filterByPeriod: data.selectedPartnerPeriod,
                      filterByStatus:
                          data.selectedPartnerStatus &&
                          (data.selectedPartnerStatus === 'active' ? 'Active' : 'Inactive'),
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export default getMembers;
